import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WorkplacesPage } from './workplaces';

@NgModule({
  declarations: [
    WorkplacesPage,
  ],
  imports: [
    IonicPageModule.forChild(WorkplacesPage),
  ],
})
export class WorkplacesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/workplaces/workplaces.module.ts